import * as jose from "jose";

export function generateToken() {
  const secret = new TextEncoder().encode("mock-secret-key");
  const jwt = new jose.SignJWT({
    user_id: "6ca9d764-5d2f-405a-b0a2-656eeac151ac",
  })
    .setProtectedHeader({ alg: "HS256", typ: "JWT" })
    .setExpirationTime("1m") // 1分で有効期限切れ
    .sign(secret);

  return jwt;
}

export function addMockDelay() {
  // 通信遅延をシミュレートする場合に使用するヘルパー関数
  // return new Promise((resolve) => setTimeout(resolve, 200));
  return Promise.resolve();
}
